import http from "../http-common";

class SoftwareAssetDataService {
    getAssets(askerId, offsetValue, warrantyStatus, expirationStartDate, expirationEndDate, licenseStatus, licenseExpirationStartDate, licenseExpirationEndDate, hasDevicesRemaining, selectedTenantId, selectedAssignedToUser, selectedAssignedAssetId, licenseNumber, searchText, sortBy, sortOrder) {
        return http.get(`/softwareAssets?askerId=${askerId}&offsetValue=${offsetValue}&warrantyStatus=${warrantyStatus}&expirationStartDate=${expirationStartDate}&expirationEndDate=${expirationEndDate}&licenseStatus=${licenseStatus}&licenseExpirationStartDate=${licenseExpirationStartDate}&licenseExpirationEndDate=${licenseExpirationEndDate}&hasDevicesRemaining=${hasDevicesRemaining}&selectedAssignedToUser=${selectedAssignedToUser}&selectedAssignedAssetId=${selectedAssignedAssetId}&licenseNumber=${licenseNumber}&searchText=${searchText}&sortBy=${sortBy}&sortOrder=${sortOrder}&selectedTenantId=${selectedTenantId}`, {
            withCredentials: true
        });
    }

    getSpecificAsset(id, tenantId, askerId) {
        return http.get(`/softwareAssets/${id}?tenantId=${tenantId}&askerId=${askerId}`, {
            withCredentials: true
        });
    }

    getHistory(id, timeZoneAdjustmentFactor) {
        return http.get(`/softwareAssets/getHistory/${id}?timeZoneAdjustmentFactor=${timeZoneAdjustmentFactor}`, {
            withCredentials: true
        });
    }

    getSpecificHistoryEventDetails(historyEventId, timeZoneAdjustmentFactor) {
        return http.get(`/softwareAssets/getSpecificHistoryEventDetails/${historyEventId}?timeZoneAdjustmentFactor=${timeZoneAdjustmentFactor}`, {
            withCredentials: true
        });
    }

    getPeopleAssignments(id) {
        return http.get(`/softwareAssets/getPeopleAssignments/${id}`, {
            withCredentials: true
        });
    }

    getHardwareAssetAssignments(id) {
        return http.get(`/softwareAssets/getHardwareAssetAssignments/${id}`, {
            withCredentials: true
        });
    }

    getPeopleAssignmentSearchResults(searchText, tenantId) {
        return http.get(`/softwareAssets/searchResults/getPeopleAssignmentSearchResults?searchText=${searchText}&tenantId=${tenantId}`, {
            withCredentials: true
        });
    }

    getHardwareAssignmentSearchResults(searchText, tenantId) {
        return http.get(`/softwareAssets/searchResults/getHardwareAssignmentSearchResults?searchText=${searchText}&tenantId=${tenantId}`, {
            withCredentials: true
        });
    }

    // create a new software asset
    createNewSoftwareAsset(data) {
        return http.post('/softwareAssets', data, {
            withCredentials: true
        });
    }

    // edit an existing software asset
    editSoftwareAsset(data, assetId) {
        return http.post(`/softwareAssets/editSoftwareAsset/${assetId}`, data, {
            withCredentials: true
        });
    }

    // create a new history event
    createHistoryEvent(data) {
        return http.post('/softwareAssets/createHistoryEvent', data, {
            withCredentials: true
        });
    }

    // assign software to a person
    assignToPerson(data) {
        return http.post('/softwareAssets/assignToPerson', data, {
            withCredentials: true
        });
    }

    // assign software to a hardware asset
    assignToHardware(data) {
        return http.post('/softwareAssets/assignToHardware', data, {
            withCredentials: true
        });
    }

    deleteSoftwarePersonAssignment(softwareId, personId, assetName, creatorId) {
        return http.delete(`/softwareAssets/deleteSoftwarePersonAssignment?softwareId=${softwareId}&personId=${personId}&assetName=${assetName}&creatorId=${creatorId}`, {
            withCredentials: true
        });
    }

    deleteSoftwareHardwareAssignment(softwareId, hardwareId, assetName, creatorId) {
        return http.delete(`/softwareAssets/deleteSoftwareHardwareAssignment?softwareId=${softwareId}&hardwareId=${hardwareId}&assetName=${assetName}&creatorId=${creatorId}`, {
            withCredentials: true
        });
    }

    // create a new contract - if possible
    createContract(data) {
        return http.post('/softwareAssets/contracts/add', data, {
            withCredentials: true,
            'Content-Type': 'multipart/form-data'
        });
    }

    getCustomers(managingTenantId) {
        return http.get(`/softwareAssets/contracts/getCustomers?managingTenantId=${managingTenantId}`, {
            withCredentials: true
        });
    }

    // get all drop down values except for customers for the drop downs on the add / edit contracts forms - gives values specific to caller's tenant where needed
    getDropdownValuesForContractForm(tenantId) {
        return http.get(`/softwareAssets/contracts/getDropdownData?tenantId=${tenantId}`, {
            withCredentials: true
        });
    }

    getAllContracts(tenantId, companyId, contractType, contractStatus, vendorId, expiresBy, searchText, sortBy, sortOrder, offset) {
        return http.get(`/softwareAssets/contracts/getAll?tenantId=${tenantId}&companyId=${companyId}&contractType=${contractType}&contractStatus=${contractStatus}&vendorId=${vendorId}&expiresBy=${expiresBy}&searchText=${searchText}&sortBy=${sortBy}&sortOrder=${sortOrder}&offset=${offset}`, {
            withCredentials: true
        });
    }

    getSpecificContract(askerId, contractId) {
        return http.get(`/softwareAssets/contracts/${contractId}/getDetails?askerId=${askerId}`, {
            withCredentials: true
        });
    }

    deleteContract(contractId, askerId, tenantId) {
        return http.delete(`/softwareAssets/contracts/${contractId}/deleteContract?askerId=${askerId}&tenantId=${tenantId}`, {
            withCredentials: true
        });
    }

    editContract(data, contractId) {
        return http.post(`/softwareAssets/contracts/${contractId}/editContract`, data, {
            withCredentials: true,
            'Content-Type': 'multipart/form-data'
        });
    }

    getSoftwareAssetsUpdatedVersion(tenantId, companyId, status, managerId, type, publisherId, searchText, sortBy, sortOrder, offset) {
        return http.get(`/softwareAssets/getAllSoftwareAssets/UpdatedVersion?tenantId=${tenantId}&companyId=${companyId}&status=${status}&managerId=${managerId}&type=${type}&publisherId=${publisherId}&searchText=${searchText}&sortBy=${sortBy}&sortOrder=${sortOrder}&offset=${offset}`, {
            withCredentials: true
        });
    }

    getDropdownValuesForSoftwareAssetFormAndFilters(tenantId) {
        return http.get(`/softwareAssets/getSoftwareAsset/dropDownData?tenantId=${tenantId}`, {
            withCredentials: true
        });
    }

    deleteSoftwareAssetUpdatedVersion(softwareId, askerId, tenantId) {
        return http.delete(`/softwareAssets/delete/${softwareId}/updatedVersion?askerId=${askerId}&tenantId=${tenantId}`, {
            withCredentials: true
        });
    }

    createCustomer(data) {
        return http.post(`/softwareAssets/contracts/customers/createNew`, data, {
            withCredentials: true
        });
    }

    getDangerContracts(askerId, selectedTenantId) {
        return http.get(`/softwareAssets/contracts/getDangerContracts?askerId=${askerId}&selectedTenantId=${selectedTenantId}`, {
            withCredentials: true
        });
    }

    getWarningContracts(askerId, selectedTenantId) {
        return http.get(`/softwareAssets/contracts/getWarningContracts?askerId=${askerId}&selectedTenantId=${selectedTenantId}`, {
            withCredentials: true
        });
    }

    deleteContractAttachment(id) {
        return http.delete(`/softwareAssets/deleteContractAttachment?id=${id}`, {
            withCredentials: true
        });
    }

    renewContract(data) {
        return http.post(`/softwareAssets/contracts/renewContract`, data, {
            withCredentials: true
        });
    }

    reverseContractRenewal(id) {
        return http.delete(`/softwareAssets/contracts/reverseContractRenewal?id=${id}`, {
            withCredentials: true
        });
    }

    assignToNotifications(data) {
        return http.post(`/softwareAssets/contracts/assignToNotifications`, data, {
            withCredentials: true
        });
    }

    removeFromNotifications(contractId, userId) {
        return http.delete(`/softwareAssets/contracts/removeFromNotifications?contractId=${contractId}&userId=${userId}`, {
            withCredentials: true
        });
    }

}

export default new SoftwareAssetDataService();